<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.0998 12.5001C17.1998 12.5001 19.7998 10.0001 19.7998 6.80007C19.7998 3.70007 17.2998 1.10007 14.0998 
    1.10007C10.8998 1.00007 8.2998 3.50007 8.2998 6.70007C8.2998 9.90007 10.8998 12.5001 14.0998 12.5001Z"
    fill="#748097"
  />
  <path
    d="M21.5002 14.6001C17.0002 14.6001 13.2002 18.3001 13.2002 22.9001C13.2002 27.5001 16.9002 31.2001 
    21.5002 31.2001C26.1002 31.2001 29.8002 27.5001 29.8002 22.9001C29.8002 18.1001 26.1002 14.6001 21.5002 
    14.6001ZM21.5002 30.0001V28.0001C18.6002 28.0001 16.3002 25.7001 16.3002 22.8001C16.3002 21.8001 16.6002 
    20.9001 17.1002 20.0001L18.1002 21.0001C17.8002 21.6001 17.7002 22.1001 17.7002 22.8001C17.7002 25.0001 
    19.5002 26.7001 21.6002 26.7001V24.8001L24.2002 27.4001L21.5002 30.0001ZM25.9002 25.6001L24.9002 24.6001C25.2002 
    24.0001 25.3002 23.5001 25.3002 22.8001C25.3002 20.6001 23.5002 18.9001 21.4002 18.9001V20.8001L18.8002 18.2001L21.4002 
    15.6001V17.5001C24.3002 17.5001 26.6002 19.8001 26.6002 22.7001C26.6002 23.8001 26.3002 24.7001 25.9002 25.6001Z"
    fill="#009DD6"
  />
  <path
    d="M11.3001 22.7C11.3001 19.3 13.1001 16.4 15.8001 14.7H9.8001C6.0001 14.7 3.1001 17.7 3.1001 21.4V24C3.1001 24.6 3.5001 
    25 4.1001 25H11.7001C11.4001 24.3 11.3001 23.5 11.3001 22.7Z"
    fill="#748097"
  />
</svg>
